import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import { faArrowLeft } from "@fortawesome/pro-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useDispatch } from "react-redux"
import { useTranslation } from "react-i18next"
import SurveyLogin from "../../pages/SurveyLogin"
import { mainSplitApi } from "../../api"
import { setLocationModal } from "../../pages/Common/commonSlice"
import styles from "../Landing/landing.module.scss"

/**
 * Auth screen for the survey lane — the counterpart of `Landing`, kept separate
 * so the two lanes' entry behaviour cannot drift into each other.
 */
const SurveyLanding = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { t: translate } = useTranslation()

    useEffect(() => {
        // Start from a clean session: a token left over from the other lane
        // would otherwise be reused here.
        localStorage.clear()
        dispatch(mainSplitApi.util.resetApiState())
        // Ask for location and camera up front — check-in photos are stamped
        // with both, and the login itself is refused without coordinates.
        dispatch(setLocationModal({ locationModal: true }))
    }, [dispatch])

    return (
        <Box sx={{ display: "flex", height: "100%" }}>
            <Box className={styles.login_wrapper}>
                <Box className={styles.login_wrapper__section}>
                    <SurveyLogin />
                    <Button
                        fullWidth
                        variant="outlined"
                        sx={{
                            width: "100%",
                            marginBottom: "auto",
                            backgroundColor: "#fff",
                            height: "48px",
                            marginTop: "15px",
                        }}
                        startIcon={<FontAwesomeIcon icon={faArrowLeft} />}
                        onClick={() => navigate("/home")}
                    >
                        {translate("backToHome")}
                    </Button>
                </Box>
            </Box>
        </Box>
    )
}

export default SurveyLanding
